// extracted by mini-css-extract-plugin
export default {"pageContainer":"Layout_pageContainer__VlyhT","contentContainer":"Layout_contentContainer__-mUOm","bgImage":"Layout_bgImage__IXypj"};